export const pushUserIdToDataLayer = (userUUID: string) => {
    if (window.dataLayer) {
        window.dataLayer.push({ userId: userUUID });
    } else {
        // eslint-disable-next-line no-console
        console.warn('Window datalayer script is not loaded.');
    }
};
